import { useEffect, useState } from "react";
import s from "./sign-offer-modal.module.scss";
import { FormProvider, useForm, Controller } from "react-hook-form";
import { Modal } from "@shared/ui/modal/modal";
import { Button } from "@shared/ui/button/button";
import { CountdownTimer } from "@shared/ui/countdown-timer/countdown-timer";
import ReactCodeInput from "react-code-input";
import { useRequestSignCode } from "../../api/useRequestSignCode";
import { useSignDocs } from "../../api/useSignDocs";

const codeInputProps = {
	className: s.codeInputs,
	inputStyle: {
		MozAppearance: "textfield",
		borderRadius: "0.5rem",
		border: "1px solid #E2E4E7",
		background: "#FFF",
		fontSize: "2rem",
		padding: "1rem 0.75rem",
		paddingLeft: "0.75rem",
		width: 53,
		textAlign: "center",
	},
	inputStyleInvalid: {
		border: "1px solid #F12828",
	},
};

export const SignOfferModal = ({ isOpen, close, profile }) => {
	const methods = useForm({ mode: "onTouched" });
	const [startTime, setStartTime] = useState(null);
	const [isExpired, setIsExpired] = useState(false);
	const [error, setError] = useState(null);
	const [loading, setLoading] = useState(false);

	const { mutate: requestCode } = useRequestSignCode({
		onMutate: () => setLoading(true),
		onSuccess: ({ data }) => {
			setStartTime(data?.code_issued_at || new Date().toISOString());
			setIsExpired(false);
			setError(null);
		},
		onError: (err) => {
			setError(err?.response?.data?.message || "Не удалось отправить код");
		},
		onSettled: () => setLoading(false),
	});

	const { mutate: signDocs } = useSignDocs({
		onMutate: () => setLoading(true),
		onSuccess: () => close(),
		onError: (err) => {
			setError(err?.response?.data?.message || "Неверный код");
		},
		onSettled: () => setLoading(false),
	});

	useEffect(() => {
		if (isOpen) requestCode();
	}, [isOpen, requestCode]);

	const handleSubmit = methods.handleSubmit((data) => {
		setError(null);
		signDocs({ code: data.code });
	});

	const handleResend = () => {
		setError(null);
		requestCode();
	};

	return (
		<Modal
			isOpen={isOpen}
			close={close}
			title="Подписание договора-оферты"
			style={{ content: { maxWidth: 420 } }}
		>
			<div className={s.modalBody}>
				<p className={s.modalSubtitle}>
					Введите код из SMS, чтобы подписать договор-оферту
				</p>
				{error && <span className={s.modalError}>{error}</span>}
				<FormProvider {...methods}>
					<form onSubmit={handleSubmit} className={s.modalForm}>
						<Controller
							name="code"
							control={methods.control}
							defaultValue=""
							rules={{
								required: "Введите код",
								pattern: {
									value: /^\d{5}$/,
									message: "Код должен состоять из 5 цифр",
								},
							}}
							render={({ field }) => (
								<ReactCodeInput
									type="number"
									fields={5}
									{...field}
									{...codeInputProps}
								/>
							)}
						/>
						<div className={s.countdownWrapper}>
							{isExpired ? (
								<button
									type="button"
									disabled={loading}
									onClick={handleResend}
								>
									Запросить код повторно
								</button>
							) : (
								<>
									Повторно запросить код можно будет через:{" "}
									{startTime && (
										<CountdownTimer
											durationInSeconds={300}
											startTime={startTime}
											timezone={profile?.timezone}
											setIsExpired={setIsExpired}
										/>
									)}
								</>
							)}
						</div>
						<Button
							label="Подписать"
							className={s.modalButton}
							fetching={loading}
							disabled={!methods?.formState?.isDirty || !methods?.formState?.isValid}
						/>
					</form>
				</FormProvider>
			</div>
		</Modal>
	);
};
